import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { updateProfileSchema2 } from "../utils/schema";
import { fetchProfile, updateProfile } from "../redux/action/authAction";
import ErrorMessage from "../components/ErrorMessage";
import { pageRoutes } from "../routes/pageRoutes";
import Loader from "../components/other/Loader";

const EditProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile, isLoading, isToggle } = useSelector(
    (state) => state?.authReducer
  );
  const [imagePreview, setImagePreview] = useState(null);
  const [profile_images, setProfileImages] = useState(profile?.profile_image ?? "./user_profile.png",);



  const initialValues = {
    full_name: profile?.full_name ?? "",
  };

  useEffect(() => {
    dispatch(fetchProfile());
  }, []);

  const handleUpdateProfile = (values) => {
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.profile);
      }
    };
    const data = new FormData();
    data.append("full_name", values?.full_name);
    {
      imagePreview && data.append("file", imagePreview);
    }

    dispatch(updateProfile({ payload: data, callback }));
  };


  if(isLoading){
    return <Loader/>
  }


  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div class="ct_white_bg ct_mt_28">
              <div class="ct_px_46">
                <div class="d-flex align-items-center justify-content-between gap-2 mb-5 flex-wrap">
                  <a
                    href="javascript:void(0)"
                    onClick={() => navigate(-1)}
                    class="ct_back_text ct_fs_18"
                  >
                    <i class="fa-solid fa-arrow-left"></i>
                    <span> Back</span>
                  </a>
                  <h4 class="ct_fs_22 ct_ff_roboto ct_fw_600 mx-auto mb-0">
                    Edit Profile
                  </h4>
                </div>

                <Formik
                  initialValues={initialValues}
                  validationSchema={updateProfileSchema2}
                  onSubmit={(values, action) => {
                    handleUpdateProfile(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <form>
                      <div class="row">
                        <div class="col-lg-6 mx-auto">
                          <div class="ct_profile_img">
                          {imagePreview ? (
                          <>
                            {" "}
                            <img
                              src={URL.createObjectURL(imagePreview)}
                              alt=""
                              className="ct_img_148"
                              accept="image/*"
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={profile_images}
                              alt=""
                              className="ct_img_148"
                            />                           
                          </>
                        )}                            
                            <label
                              for="ct_edit_profile"
                              class="ct_edit_profile_label"
                            >
                              <input
                                type="file"
                                onChange={(event) => {
                                  setImagePreview(event.target.files[0]);
                                }}
                                id="ct_edit_profile"
                                accept="image/*"
                                class="d-none"
                              />
                              <div class="ct_edit_profile_icon ct_pointer_curser">
                                <i class="fa-solid fa-pen"></i>
                              </div>
                            </label>
                          </div>

                          <div class="form-group text-start mb-4">
                            <label
                              for=""
                              class="ct_ff_roboto mb-2 ct_fw_500 ct_purple_text"
                            >
                              Full Name
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              class="ct_input form-control ct_input_40 ct_input_h_52"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.full_name}
                              placeholder="Enter full name"
                            />
                          <ErrorMessage
                            errors={errors}
                            touched={touched}
                            fieldName="full_name"
                          />
                          </div>

                          <div class="form-group text-start mb-4">
                            <label
                              for=""
                              class="ct_ff_roboto mb-2 ct_fw_500 ct_purple_text"
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              class="ct_input form-control ct_input_40 ct_input_h_52"
                              value={profile?.email}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center">
                        <button
                         class="ct_orange_btn px-5"
                        onClick={handleSubmit}
                        >Save</button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default EditProfile;
